import { makeStyles } from "tss-react/mui"
import { Box, Stack, Typography } from "@mui/material"
import { faRepeat } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import { RepeatOrderFormValues } from "../../../createOrder/components/drawer/meetingDetails/RepeatOrderDialog"
import { formatRecurrence } from "../../../createOrder/components/drawer/meetingDetails/helpers"
import { useAppLocalization } from "../../../../../modules/localization/components/AppLocalizationProvider"
import { LocalizedStrict } from "../../../../../modules/localization/components/AppLocalized"
import { getRecurringDates, groupDatesByMonth } from "./helpers"
import { AccordionSection } from "./AccordionSection"
import { useDateTime } from "../../../../../modules/localization/useDateTime"

const useStyles = makeStyles()((theme) => ({
    icon: {
        color: theme.palette.tailwind.slate[400],
        marginTop: ".25rem",
    },
}))

type RepeatOrderProps = Readonly<{
    repeatDetails: Partial<RepeatOrderFormValues>
}>

export function RepeatOrder({ repeatDetails }: RepeatOrderProps) {
    const { classes } = useStyles()
    const { l10n } = useAppLocalization()
    const dateTimeFactory = useDateTime()

    const dates = getRecurringDates(dateTimeFactory, repeatDetails)
    const grouped = groupDatesByMonth(dates)

    function renderGroupedDates(grouped: Record<string, string[]>) {
        return (
            <Stack spacing={2}>
                {Object.entries(grouped).map(([monthYear, days]) => (
                    <Box key={monthYear}>
                        <Typography fontWeight={600}>{monthYear}</Typography>
                        <Typography>{days.join(", ")}</Typography>
                    </Box>
                ))}
            </Stack>
        )
    }

    return (
        <LocalizedStrict id="confirm-order-dialog-repeat-order" attrs={{ title: true }}>
            <AccordionSection
                title="Repeat order"
                subTitle={
                    <Stack flexDirection="row" gap=".5rem">
                        <FontAwesomeIcon icon={faRepeat} className={classes.icon} />
                        <Typography variant="body1">{formatRecurrence({ values: repeatDetails, l10n })}</Typography>
                    </Stack>
                }
            >
                {renderGroupedDates(grouped)}
            </AccordionSection>
        </LocalizedStrict>
    )
}
